import type { VInputProps } from '../VInput';
import { BASE_SIZE } from '../constant';
import { joinCn } from '../util';
import createTwStyle from '../util/createTwStyle';
import type { VColorPickerProps } from './type';

const twStyle = createTwStyle<VColorPickerProps & VInputProps<'text'>>();

const getHiddenValueMargin = ({
  size,
}: VColorPickerProps & VInputProps<'text'>) => {
  switch (size) {
    case BASE_SIZE.XL:
    case BASE_SIZE.LG:
      return joinCn('mx-0');
    default:
      return joinCn('-mx-1');
  }
};

const getSize = ({
  hiddenValue,
  size,
}: VColorPickerProps & VInputProps<'text'>) => {
  switch (size) {
    case BASE_SIZE.XL:
      return joinCn(
        '[&_button]:!size-scale/24',
        !hiddenValue ? ['[&_input]:!pl-scale/32'] : [],
      );
    default:
      return joinCn(
        '[&_button]:!size-scale/16',
        !hiddenValue ? ['[&_input]:!pl-scale/24'] : [],
      );
  }
};

export default twStyle({
  clrField: ({ hiddenValue, size = BASE_SIZE.SM }) =>
    joinCn(
      '[&_button]:!pointer-events-auto [&_button]:!rounded-full',

      !hiddenValue
        ? [
            'w-full flex-1',
            '[&_button]:!left-0',
            '[&_input]:!cursor-pointer [&_input:disabled]:!cursor-not-allowed',
          ]
        : [
            '!flex items-center justify-center',
            '[&_button]:!relative [&_button]:!top-0 [&_button]:!transform-none',
            '[&_input]:pointer-events-none [&_input]:absolute [&_input]:z-[-1000] [&_input]:!m-0 [&_input]:h-0 [&_input]:w-0 [&_input]:overflow-hidden [&_input]:opacity-0',
            getHiddenValueMargin({ size }),
          ],

      getSize({ hiddenValue, size }),
    ),
});
